<template>
  <a-modal
    title="提交作品"
    :width="800"
    :maskClosable="false"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="visible = false"
  >
    <a-form :form="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
      <a-form-item label="作品名称" v-if="submitConfig.name>0">
        <a-input v-decorator="['workName', validatorRules.workName]"></a-input>
      </a-form-item>
      <a-form-item label="简介" v-if="submitConfig.desc>0">
        <a-textarea
          v-decorator="['workDesc', validatorRules.workDesc]"
        ></a-textarea>
      </a-form-item>
      <a-form-item label="承诺书" v-if="submitConfig.agreeFile>0">
        <j-upload
          v-decorator="['agreeFile', validatorRules.agreeFile]"
          :uploadTarget="'qiniu'"
          :fileType="'image'"
          uploadPath="work/"
          :number="1"
          :minFileSize="100"
          :maxFileSize="submitConfig.agreeFileSize?submitConfig.agreeFileSize:5"
          :trigger-change="true"
        ></j-upload>
        <div v-if="submitConfig.agreeFileTpl">
            <p>
            下载承诺书模板，打印后签名保存为jpg格式在此上传，图片限制{{submitConfig.agreeFileSize?submitConfig.agreeFileSize:5}}MB以内。
          </p>
          <a :href="submitConfig.agreeFileTpl" target="_blank"
            ><a-icon type="cloud-download" /> 承诺书模板下载</a
          >
        </div>
      </a-form-item>
      <a-form-item label="程序文件" v-if="submitConfig.codeFile>0">
        <j-upload
          v-decorator="['workFile', validatorRules.workFile]"
          :uploadTarget="'qiniu'"
          uploadPath="work/"
          :number="1"
          text="点击上传文件"
          :maxFileSize="submitConfig.codeSize?submitConfig.codeSize:10"
          :trigger-change="true"
        ></j-upload>
        <div v-if="submitConfig.codeFileTpl">
          <a :href="submitConfig.codeFileTpl" target="_blank"
            ><a-icon type="cloud-download" /> 程序模板下载</a
          >
        </div>
      </a-form-item>
      <a-form-item label="视频文件" v-if="submitConfig.videoFile>0">
        <j-upload
          v-decorator="['videoFile', validatorRules.videoFile]"
          :uploadTarget="'qiniu'"
          uploadPath="work/"
          :number="1"
          text="点击上传视频"
         :maxFileSize="submitConfig.videoFileSize?submitConfig.videoFileSize:100"
          :trigger-change="true"
        ></j-upload>
        <div v-if="submitConfig.videoFileTpl">
          <a :href="submitConfig.videoFileTpl" target="_blank"
            ><a-icon type="cloud-download" /> 视频模板下载</a
          >
        </div>
      </a-form-item>
      <a-form-item label="附件" v-if="submitConfig.zipFile>0">
        <j-upload
          v-decorator="['zipFile', validatorRules.zipFile]"
          :uploadTarget="'qiniu'"
          uploadPath="work/"
          :number="2"
          text="点击上传附件"
          :maxFileSize="submitConfig.zipFileSize?submitConfig.zipFileSize:100"
          :trigger-change="true"
        ></j-upload>
        <div v-if="submitConfig.zipFileTpl">
          <a :href="submitConfig.zipFileTpl" target="_blank"
            ><a-icon type="cloud-download" /> 附件模板下载</a
          >
        </div>
      </a-form-item>
    </a-form>
    <a-alert v-if="submitConfig.comment">
      <template slot="message">
          <p>{{ submitConfig.comment }}</p>
      </template>
    </a-alert>
    <br>
    <p>在{{formatTime(eventInfo.eventEnd)}}结束之前，可以重复提交作品，以最后一次为准。</p>
  </a-modal>
</template>

<script>
import { httpAction, getAction, postAction } from "@/api/manage";
import JUpload from "@/components/jeecg/JUpload";
import pick from "lodash.pick";
export default {
  name: "SubmitWorkModal",
  components: {
    JUpload,
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      model: {},
      myEvent: {},
      eventInfo: {},
      submitConfig: {
          name: 2, //作品名称
          desc: 1, //描述
          agreeFile: 1,
          agreeFileTpl: '', //承诺书模板
          agreeFileSize: 5, //承诺书大小
          codeFile: 1, //程序文件
          codeFileTpl: '', 
          codeSize: 20, //程序大小
          videoFile: 1, //视频文件
          videoFileTpl: '',
          videoFileSize: 200, //视频大小
          zipFile: 1, //附件文件
          zipFileTpl: '',
          zipFileSize: 100 //附件大小
        },
      validatorRules: {
        workName: {
          rules: [{ required: true, message: "请输入作品名称!" }],
        },
        workDesc: {
          rules: [{ required: true, message: "请输入作品描述!" }],
        },
        agreeFile: {
          rules: [
            { required: true, message: "请上传承诺书! " },
          ],
        },
        workFile: {
          rules: [{ required: true, message: "请上传程序源码文件!" }],
        },
        zipFile: {
          rules: [{ required: true, message: "请上传zip格式的附件!" }],
        },
        videoFile: {
          rules: [{ required: true, message: "请上传mp4格式的视频!" }],
        },
      },
    };
  },
  created() {},
  methods: {
    open(myEvent) {
      this.visible = true;
      this.form.resetFields()
      this.myEvent = myEvent
      this.getEventInfo(myEvent.eventId)
      //已提交作品回显
      if (myEvent.worksVOS && myEvent.worksVOS.length > 0) {
        let workInfo = myEvent.worksVOS[0];
        console.log(workInfo);
        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(workInfo, "workName", "workDesc", "workFile", "agreeFile", "zipFile", "videoFile")
          );
        });
      }
    },
    getEventInfo(eventId) {
      this.confirmLoading = true;
      getAction('/teaching/teachingEvent/queryById', { id: eventId }).then((res) => {
        if (res.success) {
          this.eventInfo = res.result
          if(this.eventInfo.submitConfig){
            this.submitConfig = JSON.parse(this.eventInfo.submitConfig)
            console.log(this.submitConfig);
            
            if(this.submitConfig.agreeFileTpl){
              this.getFileInfo(this.submitConfig.agreeFileTpl).then(url=>{
                this.submitConfig.agreeFileTpl = url
              })
            }
            if(this.submitConfig.codeFileTpl){
              this.getFileInfo(this.submitConfig.codeFileTpl).then(url=>{
                this.submitConfig.codeFileTpl = url
              })
            }
            if(this.submitConfig.videoFileTpl){
              this.getFileInfo(this.submitConfig.videoFileTpl).then(url=>{
                this.submitConfig.videoFileTpl = url
              })
            }
            if(this.submitConfig.zipFileTpl){
              this.getFileInfo(this.submitConfig.zipFileTpl).then(url=>{
                this.submitConfig.zipFileTpl = url
              })
            }
          }
          this.validatorRules.workName.rules[0].required = this.submitConfig.name==2
          this.validatorRules.workDesc.rules[0].required = this.submitConfig.desc==2
          this.validatorRules.agreeFile.rules[0].required = this.submitConfig.agreeFile==2
          this.validatorRules.workFile.rules[0].required = this.submitConfig.codeFile==2
          this.validatorRules.videoFile.rules[0].required = this.submitConfig.videoFile==2
          this.validatorRules.zipFile.rules[0].required = this.submitConfig.zipFile==2
          this.confirmLoading = false
        } else {
          this.$message.warning("活动不存在");
        }
      })
    },
    getFileInfo(id){
      return getAction('/system/sysFile/getFileUrl?id=' + id)
    },
    formatTime(time){
      if(time){
        let y = time.split('-')[0]
        let m = time.split('-')[1]
        let d = time.split(' ')[0].split('-')[2]
        let h = time.split(' ')[1].split(':')[0]
        let min = time.split(' ')[1].split(':')[1]
        return m+'月'+d+'日'+ h+':'+min
      }else{
        return ''
      }
    },
    handleOk() {
      let that = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          values.eventId = that.myEvent.eventId;
          values.eventCategory = that.myEvent.myEventCategory;
          if (that.myEvent.worksVOS && that.myEvent.worksVOS.length > 0) {
            values.id = that.myEvent.worksVOS[0].workId;
          }
          postAction("/teaching/teachingWorkScore/submitWork", values)
            .then((res) => {
              if (res.success) {
                that.visible = false;
                that.$success({
                  title: "作品提交成功",
                  content: (
                    <div>
                      <p>如需修改作品，可在活动结束前再次提交。</p>
                    </div>
                  ),
                });
                that.$emit("ok");
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style>
</style>